import styled from '@emotion/styled'
import { Container } from 'components/layout'
import { PAGE_BREAKPOINTS } from 'parameters/index'

export const LearnHeroTitle = styled.h1`
	max-width: 404px;
	line-height: 1.45;
	padding-top: 106px;

	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		padding-top: 110px;
	}
`

export const LearnHeroWrapper = styled.div`
	height: 487px;
	width: 100%;
	background-image: url('https://images.ctfassets.net/b2gucv9ghj1a/1Zl88ZHwXhs3Mgzu9HMQq9/a2b457a65ec5750eed5810cab1c88530/learn-hero.jpg?h=800&fm=webp');
	background-size: cover;
	margin-bottom: 160px;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		background-position: 65%;
		margin-bottom: 120px;
	}

	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		height: 405px;
	}
`

export const LearnHeroContainer = styled(Container)`
	position: relative;
	height: 100%;
`

export const LearnHeroCarousel = styled.div`
	position: absolute;
	bottom: -120px;
	width: 100%;
	left: 0;
	padding: 20px;

	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		bottom: -110px;
	}
`

export const CarouselTitle = styled.p`
	font-size: 18px;
	font-weight: bold;
`
